import { FC, createContext, useContext, useState } from 'react';
import { TrackingContextType, TrackingData, TrackingProviderProps } from './TrackingContext.types';

// TODO: Set initial context data
const TrackingContext = createContext<TrackingContextType | undefined>(undefined);

export const TrackingProvider: FC<TrackingProviderProps> = ({ children }) => {
    const [context, setContext] = useState<TrackingData>({});

    const updateContext = (data: TrackingData) => {
        setContext((prevData) => ({
            ...prevData,
            ...data,
        }));
    };

    return (
        <TrackingContext.Provider value={{ context, updateContext }}>
            {children}
        </TrackingContext.Provider>
    );
};

export const useTracking = (): TrackingContextType => {
    const context = useContext(TrackingContext);
    if (!context) {
        throw new Error('useTracking must be used within a TrackingProvider');
    }
    return context;
};
